import { Button } from "../ui/button";
import { ChatCircleDots, Eye, EyeSlash, ArrowBendUpLeft } from "@phosphor-icons/react";

export const waitLabel = (hours) => (hours >= 48 ? `${Math.floor(hours / 24)} days` : hours >= 24 ? "1 day" : `${hours}h`);
const waitShort = (hours) => (hours >= 48 ? `${Math.floor(hours / 24)}d` : hours >= 24 ? "1d" : `${hours}h`);

const readText = (w) => (w.read ? `read by ${w.read_by.join(", ")}, no reply yet` : "unread by the team");

/* Small amber pill for tab labels and list rows. */
export function ClientWaitingPill({ item, compact = false, className = "", testId }) {
  if (!item) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-amber-100 text-amber-800 dark:bg-amber-500/20 dark:text-amber-200 px-1.5 py-0.5 text-[10px] font-semibold whitespace-nowrap ${className}`}
      title={`${item.author} has been waiting ${waitLabel(item.hours)} for a reply · ${readText(item)}`}
      data-testid={testId}
    >
      <ChatCircleDots size={10} weight="fill" /> {compact ? waitShort(item.hours) : `Client waiting · ${waitShort(item.hours)}`}
    </span>
  );
}

/* Gentle banner at the top of the admin thread. */
export function ClientWaitingHint({ waiting, onReply, testPrefix = "note" }) {
  if (!waiting) return null;
  return (
    <div className="flex items-start gap-3 rounded-lg border border-amber-300/70 bg-amber-50 dark:border-amber-800/60 dark:bg-amber-950/30 px-3.5 py-2.5" data-testid={`${testPrefix}-client-waiting`}>
      <ChatCircleDots size={18} weight="duotone" className="text-amber-600 dark:text-amber-400 shrink-0 mt-0.5" />
      <div className="min-w-0 flex-1 text-xs">
        <p className="font-semibold text-amber-900 dark:text-amber-200">
          Client is waiting — {waiting.author} wrote {waitLabel(waiting.hours)} ago{waiting.messages > 1 ? ` (${waiting.messages} messages)` : ""} and hasn't had a reply
        </p>
        {waiting.snippet && <p className="text-amber-900/80 dark:text-amber-200/80 italic truncate mt-0.5">“{waiting.snippet}”</p>}
        <p className="inline-flex items-center gap-1 text-[11px] text-amber-800/80 dark:text-amber-300/80 mt-1" data-testid={`${testPrefix}-client-waiting-read`}>
          {waiting.read ? <><Eye size={11} /> Read by {waiting.read_by.join(", ")} — no shared reply yet</> : <><EyeSlash size={11} /> Not yet read by anyone on the team</>}
        </p>
      </div>
      {onReply && (
        <Button size="sm" variant="outline" className="h-7 text-xs border-amber-400 text-amber-900 hover:bg-amber-100 dark:text-amber-100 dark:hover:bg-amber-900/40 shrink-0" onClick={onReply} data-testid={`${testPrefix}-client-waiting-reply`}>
          <ArrowBendUpLeft size={12} className="mr-1" /> Reply to client
        </Button>
      )}
    </div>
  );
}
